import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Grid, TextField } from '@material-ui/core';
import styled, { css } from 'styled-components';
import { color } from 'styles/utils';
import cx from 'classnames';
import useInput from 'lib/hooks/useInput';
import { useDidUpdateEffect } from 'lib/utils';

import MuiWrapper from 'components/common/input/MuiWrapper';
import MuiButton from 'components/common/button/MuiButton';
import T from 'components/common/text/T';
import { icon_request_post_white, note_pencil } from 'components/base/images';
import { StyledPlainButtonOuter } from 'components/common/styled/Button';
import CustomSpan from 'components/common/text/CustomSpan';
import { partnerTypeList } from 'lib/mapper';
import Color from 'color';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { ISearchInfo, IPartnerShipState } from 'lib/types/partnerTypes';

interface PartnerModalSearchProps {
  selectedPartnerGroupIdx?: {
    value: string | null;
    onChange: (e: any) => void;
    setValue: (value: string) => void;
  };
  minorCategory: {
    value: string | null;
    onChange: (e: any) => void;
    setValue: (value: string) => void;
  };
  majorCategory: {
    value: string | null;
    onChange: (e: any) => void;
    setValue: (value: string) => void;
  };

  isSearchValue: {
    value: boolean | any;
    onChange: (e: any) => void;
    setValue: (value: boolean) => void;
  };

  partnerShipState: IPartnerShipState[];
  partnerSearchList?: ISearchInfo[];

  onClickRegisterPartner: () => void;
  onSelectPartnerSearchList: (selected: any) => void;
}

/**
 *
 *
 * @param {PartnerModalSearchProps} { selectedPartner }
 * @return {*}
 */
function PartnerModalSearch({
  // receivedRequest,
  partnerSearchList,
  majorCategory,
  minorCategory,
  isSearchValue,
  partnerShipState,
  onClickRegisterPartner,
  onSelectPartnerSearchList,
}: PartnerModalSearchProps) {
  return (
    <StyledPartnerModalSearch data-component-name="PartnerModalSearch">
      <div className="partnerModalSearch__container">
        {useMemo(
          () => (
            <>
              {minorCategory.value === 'default' && (
                <Grid container className="partnerModalSearch__register_menual_wrapper default">
                  <Grid item className="partnerModalSearch__register_menual_icon">
                    <img src={note_pencil} />
                  </Grid>
                  <Grid item className="partnerModalSearch__register_menual_box">
                    <CustomSpan fontSize={11} fontWeight={500}>
                      {'B. '}
                      <T>NO_SYNC_ID_USER_TITLE</T>
                    </CustomSpan>
                    <MuiWrapper className="partnerModalSearch__register_menual_btn_wrapper">
                      <MuiButton
                        disableElevation
                        className="partnerModalSearch__register_menual_btn"
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                          onClickRegisterPartner();
                        }}
                      >
                        <img src={icon_request_post_white} alt="icon request post" />
                        <CustomSpan
                          fontSize={13}
                          fontWeight={700}
                          marginLeft={20}
                          fontColor="#ffffff"
                        >
                          {'+ '}
                          <T>ENTER_PARTNER_INFO</T>
                        </CustomSpan>
                      </MuiButton>
                    </MuiWrapper>
                  </Grid>
                </Grid>
              )}
              {minorCategory.value === 'exist' && (
                <div className="partnerModalSearch__searched_exist_wrapper partnerExist">
                  {partnerSearchList?.map((item: any, index: number) => {
                    console.log('HDS] partnerSearchList ______ ', item);
                    return (
                      <div className="partnerExist__list_row_box" key={index}>
                        <Grid
                          container
                          className={cx(
                            `partnerExist__list_row ${
                              partnerShipState?.find((i: any) => i.state === item.state)?.text
                            }`,
                          )}
                          onClick={() => {
                            // handleSelectPartnerSearchList(item);
                            onSelectPartnerSearchList(item);
                          }}
                        >
                          <Grid item className="partnerExist__list_item_box">
                            <div className="partnerExist__list_item userInfo">
                              <div className="userInfo_type">
                                <T>{partnerTypeList.find(i => i.id === item.userTypeIdx)?.text}</T>
                              </div>
                              <div className="userInfo_section"></div>
                              <div className="userInfo_name">{item.name}</div>
                            </div>
                            <div className="partnerExist__list_item email">{item.email}</div>
                          </Grid>
                          <Grid item className="partnerExist__list_status_box">
                            <div className="partnerExist__list_status_arrow">
                              <ChevronRightIcon style={{ fontSize: '28px' }} />
                            </div>
                            <div className="partnerExist__list_status">
                              {!!partnerShipState?.find((i: any) => i.state === item.state)
                                ?.icon && (
                                <img
                                  src={
                                    partnerShipState?.find((i: any) => i.state === item.state)?.icon
                                  }
                                />
                              )}
                              <span
                                className={cx(
                                  `partnerExist__partner_status ${
                                    partnerShipState?.find((i: any) => i.state === item.state)?.text
                                  }`,
                                )}
                              >
                                <T>
                                  {partnerShipState.find((i: any) => i.state === item.state)?.code}
                                </T>
                              </span>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    );
                  })}
                </div>
              )}
              {minorCategory.value === 'empty' && (
                <div className="partnerModalSearch__searched_empty_wrapper partnerEmpty">
                  <div className="partnerEmpty__wrapper">
                    <div className="partnerEmpty__box"></div>
                    <p className="partnerEmpty__text">
                      <T>PARTNER_SEARCH_NO_EXIST</T>
                    </p>
                  </div>
                  <StyledPlainButtonOuter
                    className="partnerEmpty__register_menual_btn_wrapper"
                    backgroundColor={color.navy_blue}
                    left="50%"
                    width={370}
                    height={76}
                  >
                    <MuiButton
                      type="submit"
                      config={{
                        width: '320px',
                      }}
                      disableElevation
                      color="primary"
                      variant="contained"
                      disablebackground={color.navy_blue}
                      disablefontcolor="#ffffff"
                      className="xl border-radius-round partnerEmpty__register_menual_btn"
                      onClick={() => {
                        onClickRegisterPartner();
                      }}
                    >
                      {'+ '}
                      <T>ENTER_PARTNER_INFO</T>
                    </MuiButton>
                  </StyledPlainButtonOuter>
                </div>
              )}
            </>
          ),
          [minorCategory.value, partnerSearchList],
        )}
      </div>
    </StyledPartnerModalSearch>
  );
}

const StyledPartnerModalSearch = styled.section<{}>`
  .partnerModalSearch__container {
    .partnerModalSearch__register_menual_wrapper {
      height: 420px;
      justify-content: space-between;
      align-items: flex-start;
      .partnerModalSearch__register_menual_icon {
        img {
          width: 80px;
          height: 80px;
        }
        margin-right: 20px;
      }
      .partnerModalSearch__register_menual_box {
        width: calc(100% - 100px);
        column-gap: 15px;
        display: flex;
        flex-direction: column;
        row-gap: 15px;
        .partnerModalSearch__register_menual_btn_wrapper {
          .partnerModalSearch__register_menual_btn {
            width: 100%;
          }
        }
      }
    }
    .partnerModalSearch__searched_exist_wrapper {
      height: 420px;
      /* padding-top: 30px; */
      overflow-y: overlay;
      padding-right: 20px;
      margin-right: -20px;
      .partnerExist__list_row_box {
        height: 70px;
        border-bottom: 1px solid #eff1f8;
        display: flex;
        align-items: center;
        .partnerExist__list_row {
          align-items: center;
          justify-content: space-between;
          padding-left: 30px;
          height: 70px;

          .partnerExist__list_item_box {
            width: 350px;
            .partnerExist__list_item {
              display: flex;
              align-items: center;
              &.userInfo {
                font-size: 14px;
                margin-bottom: 8px;
                font-weight: 500;
                .userInfo_type {
                  color: #25256f;
                }
                .userInfo_name {
                  color: #303030;
                }
                .userInfo_section {
                  width: 1px;
                  height: 10px;
                  background-color: #444;
                  margin: 0 10px;
                }
              }
              &.email {
                font-size: 12px;
              }
            }
          }
          .partnerExist__list_status_box {
            .partnerExist__list_status_arrow {
              display: none;
            }
            .partnerExist__list_status {
              display: flex;
              align-items: center;
              .partnerExist__partner_status {
                line-height: 25px;
                display: flex;
                align-items: center;
              }
            }
          }

          &:hover {
            cursor: pointer;
            background-color: #00a4e3;
            border-radius: 5px 35px 35px 5px;

            .partnerExist__list_item_box {
              .partnerExist__list_item {
                &.userInfo {
                  .userInfo_type {
                    color: #ffffff;
                  }
                  .userInfo_name {
                    color: #ffffff;
                  }
                  .userInfo_section {
                    width: 1px;
                    height: 10px;
                    background-color: #ffffff;
                  }
                }
                &.email {
                  color: #ffffff;
                }
              }
            }

            .partnerExist__list_status_box {
              .partnerExist__list_status_arrow {
                width: 30px;
                height: 30px;
                color: #ffffff;
                border: 1px solid #ffffff;
                border-radius: 50%;
                margin-right: 17px;
                display: block;
              }
              .partnerExist__list_status {
                display: none;
              }
            }
            &:after {
            }
          }
        }
      }
    }
    .partnerModalSearch__searched_empty_wrapper {
      height: 390px;
      position: relative;
      margin-bottom: 30px;
      .partnerEmpty__wrapper {
        display: flex;
        align-items: center;
        flex-direction: column;
        .partnerEmpty__box {
          width: 250px;
          height: 250px;
          background-color: #fafafd;
          border-radius: 10px;
        }
      }
      .partnerEmpty__text {
        text-align: center;
        color: #b5b7c1;
        padding-top: 20px;
        font-size: 14px;

        /* width: 296px; */
        white-space: nowrap;
        text-overflow: ellipsis;
        line-height: 22px;
      }
    }

    .partnerEmpty__register_menual_btn_wrapper {
      .partnerEmpty__register_menual_btn {
        border: 1px solid #ffffff;
        position: relative;
        .partner_cancel_button {
          position: absolute;
          bottom: 0;
          right: 10px;
          border: 1px solid #ffffff;
          border-radius: 18px;
          width: 36px;
          height: 36px;
          transform: translate(-50%, -50%);
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
`;

export default React.memo(PartnerModalSearch);
